import Decimal from 'decimal.js-light';
import { DetailsBooking, Money } from 'types';

export const getDiscountVoucherAmount = ({ transactions }: DetailsBooking) =>
  transactions.reduce<Money | undefined>((voucherAmount, transaction) => {
    const transactionVoucherAmount = transaction.chargeBreakdown.voucher.paymentMethod
      ? {
          amount: new Decimal(transaction.chargeBreakdown.voucher.total)
            .abs()
            .negated()
            .toFixed(2),
          currency: 'AUD',
        }
      : undefined;
    return voucherAmount || transactionVoucherAmount;
  }, undefined);
